import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/edge': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M25.7 228.2c0.1-0.2 0.2-0.3 0.3-0.5 0 0.2 0 0.3-0.1 0.5h-0.3zM486.3 243.7l0 52.1h-314.1c1.4 128.5 191.4 124.1 272.3 67.6v104.4c-47.4 28.5-156.8 53.2-240.1 21.3-70.6-27.1-119.9-100.5-120.7-172-1.1-92.2 45.7-153.4 120.7-188.3-15.8 19.9-28 41.5-34.3 78.9h175.9c10.2-105-99.4-105-99.4-105-103.3 3.6-177.9 63.7-220.4 125 14.6-114.5 92.9-220 232.8-219.7 85 0 157.6 39.9 198.6 113.3 21 37.9 28.8 78.4 28.8 122.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/edge.js
// module id = 808
// module chunks = 0